module.exports = __webpack_public_path__ + "static/media/button.d6504dcb.png";